export default __webpack_public_path__ + "static/media/GreenStairs.cf2d89bb.png";